import Vue from 'vue'
import VueRouter from 'vue-router'

// 组件导入（注意路径和命名规范）
import App from '@/App.vue'                    // 根组件，通常是带 <router-view> 的
import Login from '@/views/login/Login.vue'
import MainContent from '@/main-content/main-content.vue'  // 改名避免冲突
import Ksrk from '@/inventory/QuickIn.vue'       // 布局组件（带侧边栏、header等）
import Ksck from '@/inventory/QuickOut.vue'
import Query from '@/inventory/Query.vue'
import cmQuery from '@/inventory/cmQuery.vue'
import DeptList from '@/views/system/deptList.vue'
import roleList from '@/views/system/roleList.vue'
import userList from '@/views/system/userList.vue'
import dictionaryList from '@/views/system/dictionaryList.vue'
import loginLog from '@/views/system/loginLogList.vue'
import operationLog from '@/views/system/operationLogList.vue'

import customerList from '@/views/basic/customerList.vue'
import supplierList from '@/views/basic/supplierList.vue'
import orderMatchingList from '@/views/basic/orderMatchingList.vue'
import stockList from '@/views/basic/stockList.vue'
import TraceableCode from '@/views/basic/traceableCode.vue'

import storeList from '@/views/basic/storeList.vue'
import productList from '@/views/basic/productList.vue'
import orderList from '@/views/basic/orderList.vue'


// 404 页面（你原来用了 Layout 做 404，不太合适，建议单独做一个）
import NotFound from '@/views/notfound/NotFound.vue'  // 请创建这个组件

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: App,  // 根路径通常指向 App（里面有 <router-view>）
        meta: {
            requiresAuth: true,
            name: '首页'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            requiresGuest: true,   // ← 关键：加这个，让已登录自动跳走
            name: '登录页'
        }
    },
    {
        path: '/kcgl',
        component: MainContent,  // ← 系统管理的主容器（建议有 <router-view>）
        meta: {
            requiresAuth: true,    // 系统管理需要登录
            name: '库存管理',
            content: 'kcgl'
        },
        children: [
            {
                path: '',
                redirect: 'userList',  // 默认跳转到用户列表
                meta: {hidden: true}
            },
            {
                path: 'ksck',
                component: Ksck, // ← 请替换成真实组件
                meta: {
                    name: '快速出库',
                    content: 'kcgl'
                }
            },
            {
                path: 'ksrk',
                component: Ksrk, // ← 替换成真实组件
                meta: {
                    name: '快速入库',
                    content: 'kcgl'
                }
            },
            {
                path: 'query',
                component: Query, // ← 替换成真实组件
                meta: {
                    name: '溯源查询',
                    content: 'kcgl'
                }
            },
            {
                path: 'cmQuery',
                component: cmQuery, // ← 替换成真实组件
                meta: {
                    name: '溯源查询',
                    content: 'kcgl'
                }
            },

        ]
    },

    {
        path: '/system',
        component: MainContent,  // ← 系统管理的主容器（建议有 <router-view>）
        meta: {
            requiresAuth: true,    // 系统管理需要登录
            name: '系统管理',
            content: 'xtgl'
        },
        children: [
            {
                path: '',
                redirect: 'userList',  // 默认跳转到用户列表
                meta: {hidden: true}
            },
            {
                path: 'userList',
                component: userList, // ← 请替换成真实组件
                meta: {
                    name: '用户管理',
                    content: 'xtgl'
                }
            },
            {
                path: 'deptList',
                component: DeptList, // ← 替换成真实组件
                meta: {
                    name: '部门管理',
                    content: 'xtgl'
                }
            },
            {
                path: 'roleList',
                component: roleList, // ← 替换成真实组件
                meta: {
                    name: '角色管理',
                    content: 'xtgl'
                }
            }
            ,
            {
                path: 'dictionaryList',
                component: dictionaryList, // ← 替换成真实组件
                meta: {
                    name: '字典管理',
                    content: 'xtgl'
                }
            },
            {
                path: 'loginLog',
                component: loginLog, // ← 替换成真实组件
                meta: {
                    name: '登录日志',
                    content: 'xtgl'
                }
            },
            {
                path: 'operationLog',
                component: operationLog, // ← 替换成真实组件
                meta: {
                    name: '操作日志',
                    content: 'xtgl'
                }
            }
        ]
    },
    {
        path: '/basic',
        component: MainContent,  // ← 系统管理的主容器（建议有 <router-view>）
        meta: {
            requiresAuth: true,    // 系统管理需要登录
            name: '基本功能',
            content: 'jbgn'
        },
        children: [
            {
                path: '',
                redirect: 'orderManage',  // 默认跳转到用户列表
                meta: {hidden: true}
            },
            {
                path: 'orderManage',
                component: orderList, // ← 请替换成真实组件
                meta: {
                    name: '订单管理',
                    content: 'jbgn'
                }
            },
            {
                path: 'productManage',
                component: productList, // ← 请替换成真实组件
                meta: {
                    name: '商品管理',
                    content: 'jbgn'
                }
            },
            {
                path: 'warehouseManage',
                component: storeList, // ← 替换成真实组件
                meta: {
                    name: '仓库管理',
                    content: 'jbgn'
                }
            },
            {
                path: 'customerManage',
                component: customerList, // ← 替换成真实组件
                meta: {
                    name: '客户管理',
                    content: 'jbgn'
                }
            },
            {
                path: 'supplierManage',
                component: supplierList, // ← 替换成真实组件
                meta: {
                    name: '供应商管理',
                    content: 'jbgn'
                }
            },
            {
                path: 'orderMatching',
                component: orderMatchingList, // ← 替换成真实组件
                meta: {
                    name: '配单管理',
                    content: 'jbgn'
                }
            }
            ,
            {
                path: 'stockManage',
                component: stockList, // ← 替换成真实组件
                meta: {
                    name: '盘库管理',
                    content: 'jbgn'
                }
            },
            {
                path: 'TraceableCode',
                component: TraceableCode, // ← 替换成真实组件
                meta: {
                    name: '溯源码生成',
                    content: 'jbgn'
                }
            }
           /* ,
            {
                path: 'equipManage',
                component: equipList, // ← 替换成真实组件
                meta: {
                    name: '设备管理',
                    content: 'jbgn'
                }
            }*/
        ]
    },
    // 404 路由一定要放最后
    {
        path: '*',
        component: NotFound,
        meta: {hidden: true}
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// 猴子补丁：静默处理 Vue Router 3.x 的重定向警告（不会影响跳转）
const originalPush = router.push
router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => {
        if (
            err.name === 'NavigationDuplicated' ||
            (err.message && err.message.includes('Redirected when going from'))
        ) {
            return Promise.resolve(err) // 静默忽略
        }
        throw err
    })
}

// 路由守卫
router.beforeEach((to, from, next) => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'

    // 【新增】0. 绝对放行：只要 meta.requiresAuth 显式设置为 false，直接通过
    // 这样即便链接带着参数，也不会被拦截
    if (to.matched.some(record => record.meta.requiresAuth === false)) {
        next()
        return
    }

    // 1. 需要登录但没登录 → 去登录页并带 redirect
    // 这里建议加上 record.meta.requiresAuth !== false 的严谨判断
    if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
        return
    }

    // 2. 已登录 + 访问需要访客的页面（如登录页） → 自动跳转
    if (to.matched.some(record => record.meta.requiresGuest) && isLoggedIn) {
        const redirect = to.query.redirect || '/'
        next(redirect)
        return
    }

    // 其他情况正常通过
    next()
})

export default router